import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';
import { LoadingIcon } from '../LoadingIcon';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  label?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
};

export function LoadingSpinner({
  className,
  size = 'sm',
  color = 'currentColor',
  label = 'Loading',
}: LoadingSpinnerProps) {
  const style: CSSProperties | undefined =
    color === 'currentColor' ? undefined : { color };

  return (
    <LoadingIcon
      label={label}
      className={twMerge(sizeClasses[size], className)}
      style={style}
    />
  );
}
